import React, { useEffect, useState } from "react";
import MasterLayout from "../../components/Layout/MasterLayout";
import { Button, Image, Row, Container, Col } from "react-bootstrap";
import logo from "../../assets/images/InicImg.png";
import {
  addCvDetails,
  updateOfferedCandidateProfile,
  offeredCandidateProfile,
  getSkillSetList,
  getQualificationDetails,
} from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { getItem, showSuccessToast } from "../../utils/Functions";
import ACTION from "../../actions";
import { Typewriter } from "react-simple-typewriter";
import { Divider, Dropdown, Menu } from "antd";
import BasicInfo from "../../components/ProfileData/BasicInfo";
import ProfessionalDetail from "../../components/ProfileData/ProfessionalDetail";
import EducationDetail from "../../components/ProfileData/EducationDetail";
import ExperienceDetail from "../../components/ProfileData/ExperienceDetail";
import AddressDetail from "../../components/ProfileData/AddressDetail";
import HelpDesk from "../../components/HelpDesk/HelpDesk";
import DocumentPreview from "../../components/DocumentPreview";
import DocumentUpload from "../../components/DocumentUpload";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import DocsUpload from "../../components/DocumentUpload/DocsUpload";

const Profile = () => {
  const dispatch = useDispatch();
  let candidateId = JSON.parse(getItem("User"))._id;
  const { OfferedCandidateProfileDetails: offeredCandidateReduxData, getCandidateCvDetails: cvInfo, skillSetList, qualificationList } = useSelector(
    (state) => state.profile
  );
  // Ensure profile page layout stays light mode background (no black sides in dark theme)
  useEffect(() => {
    document.body.classList.add("profile-orange-page-mode");
    document.documentElement.classList.add("profile-orange-page-mode");
    return () => {
      document.body.classList.remove("profile-orange-page-mode");
      document.documentElement.classList.remove("profile-orange-page-mode");
    };
  }, []);

  const [showInput, setShowInput] = useState({
    firstName: false,
    lastName: false,
    emailId: false,
    secondaryEmail: false,
    mobile: false,
    phone: false,
    gender: false,
    jobLocation: false,
    noticePeriod: false,
    currentLocation: false,
    qualification: false,
    skillSet: false,
    totalExperiance: false,
    relevantExperiance: false,
    currentSalary: false,
    expectedSalary: false,
    currentDesignation: false,
    currentEmployer: false,
    joiningDate: false,
    additionalInfo: false,
    website: false,
    skypeId: false,
    street: false,
    zipCode: false,
    city: false,
    state: false,
    country: false,
  });
  const [showResume, setShowResume] = useState(false);
  const [showResumeUpload, setShowResumeUpload] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [resumeFormData, setResumeFormData] = useState("");

  const [basicinfo, setBasicInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    secondaryEmail: "",
    mobile: "",
    phone: "",
    gender: "",
    jobLocation: "",
    noticePeriod: "",
    currentLocation: "",
    phoneCode: "",
    mobileCode: "",
  });
  const [professionaldetails, setprofessionalDetails] = useState({
    skillSet: [],
    totalExprience: "",
    relevantExperience: "",
    currentSalary: "",
    expectedSalary: "",
    currentDesignation: "",
    currentEmployer: "",
    expectedjoiningDate: new Date(),
    highestQualification: "",
    additionalInfo: "",
    portfolio: "",
    skypeId: "",
  });
  const [educationdetails, setEducationDetails] = useState([]);
  const [experiencedetails, setExperienceDetails] = useState([]);
  const [addressdetails, setaddressDetails] = useState({
    street: "",
    postalCode: "",
    city: "",
    state: "",
    country: "",
  });

  const [basicErrors, setBasicErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    secondaryEmail: "",
    mobile: "",
    phone: "",
  });
  const [professionalErrors, setProfessionalErrors] = useState({
    highestQualification: "",
    skillSet: "",
    totalExperience: "",
    currentSalary: "",
    currentDesignation: "",
    currentEmployer: "",
  });

  const [educationErrors, setEducationErrors] = useState({
    education: "",
  });
  const [addressErrors, setAddressErrors] = useState({
    city: "",
  });
  const history = useHistory();
  useEffect(() => {
    if (!offeredCandidateReduxData?.basicInfo?.email) {
      history.push("/job-opening");
    }
  }, [offeredCandidateReduxData]);

  // Fetch fresh profile data on mount so resume/photo show up correctly
  useEffect(() => {
    dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
    dispatch(getSkillSetList());
    dispatch(getQualificationDetails());
    if (candidateId) {
      dispatch(offeredCandidateProfile(candidateId));
    }
  }, []);

  // Parse CV when a new resume is uploaded / replaced with profile data
  useEffect(() => {
    if (resumeFormData) {
      // Clear stale CV so skeleton stays up until the new fetchInfo returns
      dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
      dispatch(addCvDetails(resumeFormData));
    }
  }, [resumeFormData]);

  /******************* 
  @Purpose : Auto-fill ALL form fields from CV parse (POST /candidate/fetchInfo)
  Saves CV data silently to backend so profile re-fetch carries the data into
  Redux → ProfessionalDetail / BasicInfo useEffects populate all fields correctly.
  @Author : INIC
  ******************/
  useEffect(() => {
    if (!cvInfo?.data) return;

    const {
      firstName,
      lastName,
      emailId,
      mobile,
      phone,
      currentLocation,
      currentDesignation,
      currentEmployer,
      website,
      summary,
      candidateSkillSet,
      rawSkills,
      experiences,
      educations,
      highestQualification,
      // backend may return total experience under different keys
      totalExperiance: totalExperianceA,
      totalExperience: totalExperienceA,
      totalExperienceYears: totalExperienceYearsA,
    } = cvInfo.data;

    // Normalize total experience from any variant returned by backend
    const totalExperiance =
      totalExperianceA ?? totalExperienceA ?? totalExperienceYearsA ?? null;

    const normalizeSkillName = (name) => {
      if (!name) return "";
      return String(name).toLowerCase().replace(/[^a-z0-9]/g, "");
    };

    // Prefer resume rawSkills; fall back to candidateSkillSet IDs
    const skillIds = (
      Array.isArray(rawSkills) && rawSkills.length
        ? rawSkills
          .map((name) => {
            const master = skillSetList?.find(
              (s) =>
                s.skill?.toLowerCase() === String(name).toLowerCase() ||
                normalizeSkillName(s.skill) === normalizeSkillName(name)
            );
            return master?._id;
          })
          .filter(Boolean)
        : (candidateSkillSet || []).map((s) => s._id)
    ).filter(Boolean);

    const highestQualObj =
      highestQualification && qualificationList
        ? qualificationList.find(
            (q) =>
              String(q.qualification || "").toLowerCase() ===
              String(highestQualification).toLowerCase()
          )
        : null;

    // Map experiences to the format ExperienceDetail expects
    const mappedExperiences = (experiences || []).map((exp) => ({
      occupation: exp.occupation || "",
      company: exp.company || "",
      summary: exp.summary || "",
      from: exp.from || "",
      to: exp.to || (exp.isWorking ? "Present" : ""),
    })).filter(
      (exp) =>
        exp.occupation || exp.company || exp.summary || exp.from || exp.to
    );

    const mappedEducations = (educations || []).map((edu) => ({
      institute: edu.institute || "",
      major: edu.major || "",
      from: edu.from != null ? String(edu.from) : "",
      to: edu.to != null ? String(edu.to) : "",
    })).filter((edu) => edu.institute || edu.major || edu.from || edu.to);

    // If backend didn't return total experience, compute it from experiences array
    const computeTotalYears = (exps) => {
      if (!exps || !exps.length) return null;
      let totalMonths = 0;
      exps.forEach((e) => {
        try {
          const parseDate = (d) => {
            if (!d) return null;
            // handle formats like 'Jan 2022', 'Jun 2019', 'Present'
            if (/present/i.test(d)) return new Date();
            const maybe = new Date(d);
            if (!isNaN(maybe.getTime())) return maybe;
            // try parsing 'Mon YYYY'
            const parts = d.split(" ");
            if (parts.length >= 2) return new Date(d);
            return null;
          };
          const from = parseDate(e.from);
          const to = parseDate(e.to) || new Date();
          if (from && to && !isNaN(from.getTime()) && !isNaN(to.getTime())) {
            const months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
            if (months > 0) totalMonths += months;
          }
        } catch (err) {
          // ignore parse errors
        }
      });
      if (totalMonths <= 0) return null;
      return Math.round((totalMonths / 12) * 10) / 10; // years rounded to 1 decimal
    };

    const computedTotalFromExperiences = computeTotalYears(mappedExperiences);

    // Build payload with only fields that have values
    const payload = {
      id: candidateId,
      modifiedBy: candidateId,
      phoneCode: basicinfo?.phoneCode || "91",
      mobileCode: basicinfo?.mobileCode || "91",
    };

    if (firstName) payload.firstName = firstName;
    if (lastName) payload.lastName = lastName;
    if (emailId) payload.emailId = emailId;
    if (mobile) payload.mobile = String(mobile);
    if (phone) payload.phone = String(phone);
    if (currentLocation) payload.currentLocation = currentLocation;
    if (currentDesignation) payload.currentDesignation = currentDesignation;
    if (currentEmployer) payload.currentEmployer = currentEmployer;
    const finalTotal = totalExperiance != null ? totalExperiance : computedTotalFromExperiences;
    if (finalTotal != null) payload.totalExperiance = String(finalTotal);
    // Update local professionaldetails state immediately so UI shows parsed value
    if (finalTotal != null) {
      setprofessionalDetails((prev) => ({
        ...prev,
        totalExprience: String(finalTotal),
        totalExperiance: String(finalTotal),
      }));
    }
    if (website) payload.portfolio = website;
    if (summary) payload.additionalInfo = summary;
    if (skillIds.length) payload.skillSet = skillIds;
    if (highestQualObj) payload.qualification = highestQualObj._id;
    if (mappedExperiences.length) payload.experiences = mappedExperiences;
    if (mappedEducations.length) payload.educations = mappedEducations;

    if (mappedEducations.length) {
      setEducationDetails(mappedEducations);
    }
    if (mappedExperiences.length) {
      setExperienceDetails(mappedExperiences);
    }

    // Silent = true → no success toast, just save + re-fetch profile
    dispatch(updateOfferedCandidateProfile(payload, true));
    
    // Clear cvInfo so we don't process it again
    dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
  }, [cvInfo]);


  useEffect(() => {
    if (offeredCandidateReduxData?.resume) {
      setResumeUrl(
        offeredCandidateReduxData?.resume?.startsWith("https://")
          ? offeredCandidateReduxData?.resume
          : offeredCandidateReduxData.FILE_PATH +
          offeredCandidateReduxData.resume
      );
    }
  }, [offeredCandidateReduxData?.resume]);

  useEffect(() => {
    if (offeredCandidateReduxData?.photo) {
      setPhotoUrl(
        offeredCandidateReduxData.FILE_PATH + offeredCandidateReduxData.photo
      );
    }
  }, [offeredCandidateReduxData?.photo]);

  const handleShowInput = (e) => {
    setShowInput({ ...showInput, [e]: !showInput[e] });
  };

  const handleUpdate = (name, value) => {
    dispatch(
      updateOfferedCandidateProfile({
        id: candidateId,
        [name]: value,
        modifiedBy: candidateId,
        phoneCode: basicinfo?.phoneCode,
        mobileCode: basicinfo?.mobileCode,
      })
    );
    setShowInput({ ...showInput, [name]: !showInput[name] });
  };


  const logoutHandler = () => {
    history.push("/");
    localStorage.clear();
    showSuccessToast("Logout Successfully");
  };

  const userMenu = (
    <Menu
      className="profile-orange-user-menu"
      items={[
        {
          key: "logout",
          label: (
            <a
              onClick={logoutHandler}
              className="d-flex align-items-center text-danger fw-medium text-decoration-none"
            >
              <i className="bx bx-log-out me-2 fs-5"></i> Logout
            </a>
          ),
        },
      ]}
    />
  );

  /******************* 
  @purpose : Rander HTML/ React Components 
  ******************/
  return (
    <MasterLayout hideChrome>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');
        .profile-fraunces-title {
          font-family: 'Fraunces', serif !important;
          font-style: italic !important;
          font-weight: 600 !important;
          color: #fffaf3 !important;
          letter-spacing: -0.03em;
          line-height: 1.1;
        }
        .profile-fraunces-subtitle {
          font-family: 'Poppins', sans-serif !important;
          font-style: normal !important;
          font-weight: 600 !important;
          color: rgba(255, 250, 243, 0.82) !important;
          letter-spacing: -0.01em;
          line-height: 1.5;
        }
        .profile-fraunces-dark {
          font-family: 'Fraunces', serif !important;
          font-style: italic !important;
          font-weight: 600 !important;
          color: #1e2433 !important;
          letter-spacing: -0.03em;
          line-height: 1.1;
        }
      `}</style>
      <div className="profile-orange-shell">
        <aside className="profile-orange-aside">
          <div className="profile-orange-brand">
            <Image
              src={logo}
              variant="top"
              className="header-img"
              alt="IndiaNIC Logo"
            />
          </div>
          <h1 className="profile-fraunces-title">Your next opportunity awaits</h1>
          <p className="profile-fraunces-subtitle">
            Fill in your details and let us know why you&apos;re a great fit for
            the team.
          </p>

          <div className="profile-orange-checklist">
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => { document.getElementById('section-upload')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              <span className={`check-dot ${resumeUrl ? 'done' : ''}`}>
                {resumeUrl ? '✓' : '1'}
              </span>
              <span>Upload documents</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => { document.getElementById('section-basic-info')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              <span className="check-dot done">✓</span>
              <span>Basic info</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => { document.getElementById('section-professional')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              <span className="check-dot done">✓</span>
              <span>Professional details</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => { document.getElementById('section-education')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              <span className={`check-dot ${
                (educationdetails?.length > 0 ||
                  offeredCandidateReduxData?.educationalDetails?.length > 0 ||
                  offeredCandidateReduxData?.educations?.length > 0)
                  ? 'done' : ''
              }`}>
                {(educationdetails?.length > 0 ||
                  offeredCandidateReduxData?.educationalDetails?.length > 0 ||
                  offeredCandidateReduxData?.educations?.length > 0)
                  ? '✓' : '4'}
              </span>
              <span>Education details</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => { document.getElementById('section-experience')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              <span className={`check-dot ${
                (experiencedetails?.length > 0 ||
                  offeredCandidateReduxData?.experienceDetails?.length > 0 ||
                  offeredCandidateReduxData?.experiences?.length > 0)
                  ? 'done' : ''
              }`}>
                {(experiencedetails?.length > 0 ||
                  offeredCandidateReduxData?.experienceDetails?.length > 0 ||
                  offeredCandidateReduxData?.experiences?.length > 0)
                  ? '✓' : '5'}
              </span>
              <span>Experience details</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => { document.getElementById('section-address')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              <span className="check-dot done">✓</span>
              <span>Address details</span>
            </button>
          </div>

          <div className="profile-orange-aside-foot">
            <strong>Need help?</strong>
            <a href="tel:+917961916000" className="profile-orange-contact-link">
              <i className="bx bx-phone" aria-hidden="true" />
              <span>+91 79 6191 6000</span>
            </a>
            <a href="mailto:hr@indianic.com" className="profile-orange-contact-link">
              <i className="bx bx-envelope" aria-hidden="true" />
              <span>hr@indianic.com</span>
            </a>
          </div>
        </aside>

        <main className="profile-orange-main profile-page" id="offer-approval">
          <div className="profile-orange-top-row">
            <div className="profile-orange-title-col">
              <button
                type="button"
                className="profile-orange-back-arrow"
                onClick={() => history.push("/add-profile")}
                title="Back"
              >
                <i className="bx bx-arrow-back" />
              </button>
              <h2 className="profile-fraunces-dark">
                {offeredCandidateReduxData?.basicInfo?.firstName
                  ? `${offeredCandidateReduxData.basicInfo.firstName} ${offeredCandidateReduxData.basicInfo.lastName || ''}`
                  : 'Your Profile'}
              </h2>
            </div>
            <Dropdown
              overlay={userMenu}
              placement="bottomCenter"
              trigger={["click"]}
              arrow={{ pointAtCenter: true }}
              align={{ offset: [0, -8] }}
            >
              <button
                type="button"
                className={`profile-orange-user-avatar ${photoUrl ? "has-photo" : ""}`}
                title="Account"
              >
                {photoUrl ? (
                  <img
                    src={photoUrl}
                    alt="Profile"
                    style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
                    onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                  />
                ) : null}
                <i className="bx bx-user" style={photoUrl ? { display: "none" } : {}} />
              </button>
            </Dropdown>
          </div>

          <div className="consultant-add-form-body">
            <div className="panel profile-orange-panel">
              {/* Upload Documents */}
              <div className="panel-header sec-head" id="section-upload">
                <div className="sec-num"><i className="bx bx-upload" /></div>
                <div className="title">Upload Documents</div>
              </div>
              <div className="panel-content profile-orange-upload-content">
                <div className="profile-orange-upload-row">
                  <div className="profile-orange-dropzone">
                    <DocsUpload
                      setModalShow={setShowResumeUpload}
                      modalShow={showResumeUpload}
                      isGuest={false}
                      type={"resume"}
                      resume={resumeUrl}
                      setResume={setResumeUrl}
                      resumeDetails={offeredCandidateReduxData}
                      setResumeFormData={setResumeFormData}
                    />
                  </div>
                  <div className="profile-orange-pfp">
                    <DocsUpload
                      setModalShow={setShowResumeUpload}
                      modalShow={showResumeUpload}
                      isGuest={false}
                      type={"profile"}
                      photo={photoUrl}
                      setPhoto={setPhotoUrl}
                      resume={resumeUrl}
                      setResume={setResumeUrl}
                      resumeDetails={offeredCandidateReduxData}
                    />
                  </div>
                </div>
              </div>

              {/* Basic Info */}
              <BasicInfo
                basicInfo={offeredCandidateReduxData?.basicInfo}
                showInput={showInput}
                handleShowInput={handleShowInput}
                handleUpdate={handleUpdate}
                basicinfo={basicinfo}
                setBasicInfo={setBasicInfo}
                errors={basicErrors}
                setErrors={setBasicErrors}
                isGuest={false}
              />

              {/* Professional Details */}
              <ProfessionalDetail
                professionalDetails={offeredCandidateReduxData?.professionalDetails}
                showInput={showInput}
                handleShowInput={handleShowInput}
                handleUpdate={handleUpdate}
                professionaldetails={professionaldetails}
                setprofessionalDetails={setprofessionalDetails}
                errors={professionalErrors}
                setErrors={setProfessionalErrors}
                isGuest={false}
              />

              {/* Education Details */}
              <div id="section-education">
                <EducationDetail
                  educationalDetails={
                    offeredCandidateReduxData?.educationalDetails ||
                    offeredCandidateReduxData?.educations
                  }
                  candidateId={candidateId}
                  educationdetails={educationdetails}
                  setEducationDetails={setEducationDetails}
                  errors={educationErrors}
                  setErrors={setEducationErrors}
                  isGuest={false}
                />
              </div>

              {/* Experience Details */}
              <div id="section-experience">
                <ExperienceDetail
                  experienceDetails={
                    offeredCandidateReduxData?.experienceDetails ||
                    offeredCandidateReduxData?.experiences
                  }
                  candidateId={candidateId}
                  experiencedetails={experiencedetails}
                  setExperienceDetails={setExperienceDetails}
                  isGuest={false}
                />
              </div>

              {/* Address Details */}
              <AddressDetail
                addressDetails={offeredCandidateReduxData?.addressDetails}
                showInput={showInput}
                handleShowInput={handleShowInput}
                handleUpdate={handleUpdate}
                addressdetails={addressdetails}
                setaddressDetails={setaddressDetails}
                errors={addressErrors}
                setErrors={setAddressErrors}
                isGuest={false}
              />
            </div>
          </div>
        </main>
      </div>

      <DocumentPreview
        setModalShow={setShowResume}
        docs={[{ uri: resumeUrl }]}
        modalShow={showResume}
        isGuest={false}
      />
      <DocumentUpload
        setModalShow={setShowResumeUpload}
        type={"resume"}
        modalShow={showResumeUpload}
        resumeDetails={offeredCandidateReduxData}
      />
    </MasterLayout>
  );
};

export default Profile;
